/*
 * @Author: Superficial
 * @Date: 2021-05-08 11:18:34
 * @LastEditTime: 2021-08-19 14:43:23
 * @Description: 缓存相关工具
 */

const TokenKey = 'vue_admin_template_token'
const userKey = 'vue_admin_template_getUserInfo'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}
export function getUserInfo() {
  return localStorage.getItem(userKey)
}

export function setUserInfo(Info) {
  return localStorage.setItem(userKey, Info)
}

export function removeUserInfo() {
  return localStorage.removeItem(userKey)
}



// WEBPACK FOOTER //
// ./src/comm/utils/auth.js